// extracted by mini-css-extract-plugin
module.exports = {"choose":"Pricing_choose__2rIyT","pricing":"Pricing_pricing__WXLbF"};